import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates } from '../../util/maps';
import { Heading, Map } from '../../components';

import css from './ListingPage.module.css';

/**
 * The SectionMapMaybe component.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {propTypes.latlng} [props.geolocation] - The geolocation
 * @param {propTypes.uuid} props.listingId - The listing id
 * @returns {JSX.Element} section map maybe component
 */
class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: true };
  }

  render() {
    const { className, rootClassName, geolocation, publicData, listingId, mapsConfig, distanceString } = this.props;

    if (!geolocation) {
      return null;
    }

    const address = publicData && publicData.location ? publicData.location.address : '';
    const classes = classNames(rootClassName || css.sectionMap, className);
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;

    const mapProps = mapsConfig.fuzzy.enabled
      ? { obfuscatedCenter: obfuscatedCoordinates(geolocation, mapsConfig.fuzzy.offset, cacheKey) }
      : { address, center: geolocation };
    const map = <Map {...mapProps} useStaticMap={this.state.isStatic} />;

    const parts = address.split(',').map(p => p.trim());
    let displayAddress = address;
    if (parts.length >= 2) {
      displayAddress = `${parts[0]}, ${parts[1]}`;
    }
    const distance = distanceString || null;

    return (
      <section className={classes} id="listing-location">
        <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
          <FormattedMessage id="ListingPage.locationTitle" defaultMessage="Location" />
        </Heading>
        <div className={css.mapCardContainer}>
          {this.state.isStatic ? (
            <button
              className={css.map}
              onClick={() => {
                this.setState({ isStatic: false });
              }}
              aria-label="View interactive map"
            >
              {map}
              <div className={css.mapPinIconInCenter}>
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ color: '#7b5a45' }}
                >
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
            </button>
          ) : (
            <div className={css.map}>{map}</div>
          )}

          <div className={css.mapDetailsBar}>
            <div className={css.mapLocationTextContainer}>
              <span className={css.mapAddress}>{displayAddress}</span>
              {distance && <span className={css.mapDistance}>{distance}</span>}
            </div>
            <button
              className={css.viewOnMapButton}
              onClick={() => {
                this.setState(prevState => ({ isStatic: !prevState.isStatic }));
              }}
            >
              {this.state.isStatic ? (
                <FormattedMessage id="ListingPage.viewOnMap" defaultMessage="View on Map" />
              ) : (
                <FormattedMessage id="ListingPage.closeMap" defaultMessage="Close Map" />
              )}
            </button>
          </div>
        </div>
      </section>
    );
  }
}

export default SectionMapMaybe;
